import React from "react";
import Layout from "components/Layout";
import Widget from "components/Widget";
import CharacterOfPainTable from "components/Table/List";
import DeleteConfirm from "components/Modal/DeleteConfirm";
import EditPhysician from "./components/EditPhysician";
import TableAction from "components/Table/Actions/ActionDropdown";
import AddPhysician from "./components/AddPhysician";
import UploadCSV from "components/uploadCSV";
import SearchBox from "components/Filters/SearchBox";
import ShowModal from "components/Modal/ShowModal";
import { Tag } from "antd";

const Index = () => {
  const columns = [
    {
      title: "Name",
      render: (record) => <span>{record.painSpecialistName}</span>,
      key: "symptomName",
    },
    {
      title: "",
      render: (record) => <TableAction menu={renderActions(record)} />,
      key: "action",
      width: 50,
    },
  ];

  const renderActions = (record) => {
    return (
      <div className="gx-d-flex gx-flex-column">
        <ShowModal
          record={record}
          modalName={"Edit_Physician_Modal"}
          buttonName="Edit"
        />
        <DeleteConfirm
          type="deleteCharacterOfPain"
          method="DELETE"
          selectedItem={record}
          apiRequest="DeleteRecord"
          recordName="physicianList"
          buttonName="Yes"
          oKText="Delete"
          title="Are you sure you want to delete this physician?"
          Icon="Delete"
        />
      </div>
    );
  };

  return (
    <Layout>
      <Widget
        styleName="mainTable"
        title={
          <div className="gx-d-flex gx-flex-column">
            <span>PHYSICIAN</span>
            <a
              className="gx-m-0"
              href="https://painles.s3.amazonaws.com/1654281091511-painSpecialistName-1%20-%20Sheet1.csv"
            >
              <Tag className="gx-m-0" color="blue">
                Download CSV Sample
              </Tag>
            </a>
          </div>
        }
        extra={
          <div className="gx-d-flex" style={{ gap: "20px" }}>
            <SearchBox
              apiName="getPainManagementSpecialist"
              recordName="physicianList"
              requestType="FetchRecord"
              customQuery={{ query: "search", key: "name" }}
              placeholder="Search By Name"
              width="200px"
            />
            <UploadCSV
              type="getPainManagementSpecialist"
              url="bulkImportSkills"
              table="PainManagementSpecialist"
              recordName="physicianList"
              cb="painSpecialistName"
              uId="physicianId"
            />
            <AddPhysician />
          </div>
        }
      >
        <CharacterOfPainTable
          apiName="getPainManagementSpecialist"
          recordName="physicianList"
          scroll={true}
          pagination={true}
          columns={columns}
        />
      </Widget>
      <EditPhysician />
    </Layout>
  );
};
export default Index;
